export const allStatus = {
    open: {
        color: 'light-blue',
    },
    won: {
        color: 'green',
        icon: 'check',
    },
    lost: {
        color: 'red',
    },
    late: {
        color: 'orange',
    },
    cancelled: {
        color: 'gray',
    },
    close: {
        color: 'gray',
    },
    closed: {
        color: 'gray',
    },
    wait: {
        color: 'yellow',
    },
    pending: {
        color: 'yellow',
    },
    partial: {
        color: 'teal',
    },
    delivered: {
        color: 'green',
        icon: 'check',
    },
    draft: {
        color: 'purple',
    },
    sent: {
        color: 'light-blue',
    },
    due: {
        color: 'yellow',
    },
    read: {
        color: 'light-blue',
    },
    accepted: {
        color: 'green',
        icon: 'check',
    },
    refused: {
        color: 'red',
    },
    expired: {
        color: 'orange',
    },
    advanced: {
        color: 'yellow',
    },
    invoiced: {
        color: 'teal',
    },
    partialinvoiced: {
        color: 'teal',
    },
    partialInvoiced: {
        color: 'teal',
    },
    payinprogress: {
        color: 'teal',
    },
    paid: {
        color: 'green',
        icon: 'check',
    },
    stored: {
        color: 'yellow',
    },
    partialspend: {
        color: 'teal',
    },
    spent: {
        color: 'green',
        icon: 'check',
    },
    undefined: {
        color: 'yellow',
    },
    reconciled: {
        color: 'green',
    },
    warning: {
        color: 'orange',
    },
    disabled: {
        color: 'gray',
    },
    enabled: {
        color: 'light-blue',
    },
    completed: {
        color: 'green',
        icon: 'check',
    },
    none: {
        color: 'gray',
    },
    active: {
        color: 'green',
    },
};

export const deliveryStatus = {
    none: {
        color: 'gray',
    },
    wait: {
        color: 'yellow',
    },
    waitingsent: {
        color: 'yellow',
    },
    partial: {
        color: 'teal',
    },
    partialsent: {
        color: 'teal',
    },
    picking: {
        color: 'teal',
    },
    delivered: {
        color: 'green',
        icon: 'check',
    },
    sent: {
        color: 'green',
        icon: 'check',
    },
};

export const ocrState = {
    completed: {
        color: 'green',
        icon: 'check',
    },
    error: {
        color: 'red',
    },
    processing: {
        color: 'yellow',
    },
    pending: {
        color: 'yellow',
    },
};

export const bankStatus = {
    error: {
        color: 'red',
    },
    manual: {
        color: 'green',
        icon: 'check',
    },
    deleted: {
        color: 'red',
    },
    connected: {
        color: 'green',
        icon: 'check',
    },
    disconnected: {
        color: 'gray',
    },
};

export const promotionStatus = {
    finished: {
        color: 'gray',
    },
    inprogress: {
        color: 'light-blue',
    },
    stopped: {
        color: 'gray',
    },
    waiting: {
        color: 'yellow',
    },
};

export const importStatus = {
    queued: {
        color: 'yellow',
    },
    processing: {
        color: 'teal',
    },
    processed: {
        color: 'green',
        icon: 'check',
    },
    cancelled: {
        color: 'gray',
    },
    reverting: {
        color: 'teal',
    },
    reverted: {
        color: 'gray',
    },
    failed: {
        color: 'red',
    },
};
